import { AppServices } from '@singularsystems/neo-core';
import { NeoReactTypes } from "@singularsystems/neo-react";
import { IPluralizer } from './Services/Pluralizer';
import { ISTUtils } from './Services/STUtils';
import { AppService } from './Services/AppService';
import { ICommonConfig } from './Models/Config/ICommonConfig';
import { IAppLayoutCommon } from "./Services/IAppLayoutCommon";
import { ISTAuthenticationService } from "./Services/Security/AuthenticationServiceBase";

// Symbols to expose outside of this module
const CommonTypes = {
    Neo: {
        ...AppServices.NeoTypes,
        ...NeoReactTypes
    },
    Services: {
        STUtils: new AppServices.ServiceIdentifier<ISTUtils>("Shared.Services.Utils"),
        Pluralizer: new AppServices.ServiceIdentifier<IPluralizer>("Shared.Services.Pluralizer"),
        AppLayout: new AppServices.ServiceIdentifier<IAppLayoutCommon>("Shared.Services.AppLayout"),
        /** ST Typed pointer to neo auth service */
        STAuthenticationService: AppServices.NeoTypes.Security.AuthenticationService.asType<ISTAuthenticationService>(),
    },
    Config: AppServices.NeoTypes.Config.ConfigModel.asType<ICommonConfig>(),
}

export { CommonTypes, AppService };